<template>
    <div>
        <div class="box" id="uniform">
            <div v-if="showList">
                <div class="box-offset">
                    <div class="box-ttl-wrap">
                        <div class="box-ttl">
                            Uniforms
                        </div>
                    </div>
                    <div class="customise-tabs">
                        <div class="nav-tabs-wrap  pb-4">
                            <ul class="nav nav-tabs nav-tabs-three">
                                <li class="nav-item">
                                    <a class="nav-link" :class="{ 'active': this.activeTab === 'Pending' }"
                                       @click="changeTab('Pending')">Pending</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" :class="{ 'active': this.activeTab === 'Current' }"
                                       @click="changeTab('Current')">Current</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" :class="{ 'active': this.activeTab === 'Returned' }"
                                       @click="changeTab('Returned')">Returned</a>
                                </li>
                            </ul>
                        </div>

                        <div class="tab-content">
                            <div class="tab-pane fade show active">
                                <div class="buttons--row buttons--row-2 mb-3">
                                    <div class="search--block search--block-width">
                                        <button
                                            class="search--block-btn"
                                            type="submit"
                                            @click="getListOfApplicantsUniformRequests"

                                        ><img src="/img/svg/icons-search.svg" alt=""></button>
                                        <input
                                            type="search"
                                            class="search--block-txt"
                                            placeholder="Search by Item"
                                            v-model="filters.search"
                                            @input="handleSearch"
                                        />
                                    </div>
                                    <button v-if="activeTab === 'Pending'" @click="showExtraTab('NewRequest')"
                                            class="btn btn--outline-primary btn--middle">+ Add New
                                    </button>
                                    <button v-if="activeTab ==='Returned'" @click="showExtraTab('Return')"
                                            class="btn btn--outline-primary btn--middle">Return Uniform
                                    </button>
                                </div>
                                <div class="table-holder table-responsive">
                                    <table class="table table-uniform">
                                        <thead>
                                        <tr>
                                            <th>Date <br/>Requested</th>
                                            <th>Item</th>
                                            <th class="text-center">Size</th>
                                            <th class="text-center">Qty</th>
                                            <th v-show="activeTab !== 'Returned'">Primary Location</th>
                                            <th v-show="activeTab === 'Pending'">Status</th>
                                            <th class="comments">Comments</th>
                                            <th v-show="activeTab !== 'Returned'">Requested by</th>
                                            <th v-show="activeTab === 'Returned'"></th>
                                            <th v-show="activeTab !== 'Current'" class="text-right" style="width: 5rem">Action</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-if="loading"> <div class="lds-dual-ring"></div></tr>
                                        <tr
                                            v-else
                                            v-for="request in uniformRequests"
                                            :key="request.id"
                                            v-show="request.quantity !== '0'">
                                            <td>
                                                <div class="text-14 color--text-gray">
                                                    {{ calculateDateSlash(request.created_at) }}
                                                </div>
                                            </td>
                                            <td>
                                                {{ request.uniform.title }}
                                            </td>
                                            <td class="text-center">
                                                {{ request.size }}
                                            </td>
                                            <td class="text-center">
                                                {{ request.quantity }}
                                            </td>
                                            <td v-show="activeTab !== 'Returned'">
                                                {{ request.client ? request.client.name : request.address }}
                                            </td>
                                            <td v-show="activeTab === 'Pending'">
                                                <div class="form-group form-group-1 mb-0" style="width: 210px">
                                                    <select
                                                        class="custom-select custom-select-blue"
                                                        v-model="request.status_id"
                                                        @change="updateStatus(request)">
                                                        <option
                                                            v-for="status in statusList"
                                                            :key="status.id"
                                                            :value="status.id"
                                                            :selected="request.status_id"
                                                        >
                                                            {{ status.title }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </td>
                                            <td v-if="request.comment">
                                                <p>{{ truncatedString(request.comment)}}</p>
                                                <a
                                                    v-show="request.comment.length > 20"
                                                    href="javascript:void(0)"
                                                    class="color--secondary ml-2"
                                                    @click="showCustomModal('comment', request.id)"><i class="fas fa-eye"></i></a>

                                                <EyesShowModal
                                                    :title="`Comments`"
                                                    :modal-text="request.comment"
                                                    :modalId="getCustomModalId('comment', request.id)"
                                                ></EyesShowModal>

                                            </td>
                                            <td v-else></td>
                                            <td v-if="activeTab !== 'Returned'">
                                                <b>{{ request.requested_user.name ?? ''}} {{ request.requested_user.last_name ?? ''}}</b>
                                            </td>
                                            <td v-else></td>
                                            <td class="text-right"
                                                v-show="activeTab !== 'Current'"
                                            >
                                                <div class="action-block">
                                                    <a :href="`/master-admin/uniforms/requests/${request.id}/update?applicant_id=${userInfo.id}`"
                                                       class="edit-link"
                                                       v-show="activeTab === 'Pending'"
                                                    >
                                                        <img src="/img/svg/icons-pen.svg" alt="edit">
                                                    </a>
                                                    <button class="delete-link"
                                                            @click="showDeleteModal(request.id, 'uniform')"
                                                    >
                                                        <img src="/img/svg/on.svg" alt="delete">
                                                    </button>

                                                    <ActionModal confirm-text="Yes" reject-text="No"
                                                                 :modalId="getDeleteModalId(request.id, 'uniform')"
                                                                 @confirm="deleteRequestItem(request.id)">
                                                        <template #body>
                                                            <div class="text-center mb-4">
                                                                <h4>
                                                                    Are you sure you want <br> to delete this item?
                                                                </h4>
                                                            </div>
                                                        </template>
                                                    </ActionModal>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Pagination
                        :currentPage="pagination.current_page"
                        :lastPage="pagination.last_page"
                        @changePage="changePage"
                        @changeItemsPerPage="changeItemsPerPage"
                    />
                </div>
            </div>

            <NewUniformRequest
                :specific-applicant="true"
                :userName="userInfo.name + ' ' + userInfo.last_name"
                :userId="userInfo.id"
                v-if="showNewRequest"
            ></NewUniformRequest>

            <ReturnedUniform
                v-if="showNewReturnRequest"
                :user-name="userInfo.name + ' ' + userInfo.last_name"
                :user-id="userInfo.id"
                :link="`/master-admin/applicants/${userInfo.id}/show?tab=Uniforms`"
            ></ReturnedUniform>
        </div>
    </div>

</template>

<script>

import NewUniformRequest from "../../../../Uniforms/resources/js/NewUniformRequest.vue";
import ActionModal from "../../../../../../resources/js/components/ActionModal.vue";
import EyesShowModal from "../../../../../../resources/js/components/EyesShowModal.vue";
import CommonService from "../../../../AppUser/resources/js/services/CommonService";
import UniformsService from "../../../../Uniforms/resources/js/service/UniformsService";
import ReturnedUniform from "../related/ReturnedUniform.vue";
import DateConverter from "../../../../../../resources/js/mixins/DateConverter";
import StyleHandler from "../../../../../../resources/js/mixins/StyleHandler";
import ModalHandler from "../../../../../../resources/js/mixins/ModalHandler";
import _ from "lodash";
import SortDirectionHandler from "../../../../../../resources/js/mixins/SortDirectionHandler";
import {createDebouncedFunction} from "../../../../../../resources/js/plugins/debounce";
import Pagination from "../../../../../../resources/js/components/Pagination.vue";
import PaginationHandler from "../../../../../../resources/js/mixins/PaginationHandler";
import EmployeeUniformsService from "../../../../Uniforms/resources/js/service/EmployeeUniformsService";

export default {
    name: 'Uniforms',
    components: {
        Pagination,
        ReturnedUniform,
        EyesShowModal,
        ActionModal,
        NewUniformRequest
    },
    props: {
        userInfo: {
            type: Object
        }
    },
    mixins: [DateConverter, StyleHandler, ModalHandler, SortDirectionHandler, PaginationHandler],
    data() {
        return {
            filters: {
                search: '',
                page: 1,
                perPage: 10,
                status: ""
            },
            pagination: {
                current_page: 1,
                last_page: 1,
            },
            activeTab: 'Pending',
            loading: true,
            statusList: [],
            showNewRequest: false,
            showNewReturnRequest: false,
            showList: true,
            uniformRequests: [],
        }
    },
    methods: {
        async loadData() {
            this.loading = true;

            try {
                await Promise.all([
                    this.getStatusList(),
                    this.getListOfApplicantsUniformRequests()
                ]);
            } catch (e) {
                console.error("Error loading data");
            } finally {
                this.loading = false;
            }
        },
        handleSearch() {
            this.filters.page = 1
            this.delayedSearch();
        },

        getList(filters) {
            this.getListOfApplicantsUniformRequests(filters)
        },

        delayedSearch: _.debounce(function() {
            this.getListOfApplicantsUniformRequests()
        }, 500),

        async getListOfApplicantsUniformRequests() {
            try {
                const { data: response } = await UniformsService.getEmployeeListOfRequests(this.userInfo.id, this.filters)
                this.uniformRequests = response.data
                this.pagination.current_page = response.current_page
                this.pagination.last_page = response.last_page
                this.loading = false
            } catch (e) {
                this.$showErrorMessage('Failed to load the list of requests. Please reload the page');
            }
        },

        changeTab(tabName) {
            this.loading = true
            this.activeTab = tabName;
            if (tabName === 'Pending') {
                this.filters.status = ''
                this.getListOfApplicantsUniformRequests()
            } else if (tabName === 'Current') {
                this.filters.status = 'Completed'
                this.getListOfApplicantsUniformRequests()
            } else if (tabName === 'Returned') {
                this.getReturnedUniforms()
            }
        },
        async deleteRequestItem(id) {
            this.$showLoadingMessage()
            try {
                this.uniformRequests = this.uniformRequests.filter((request) => request.id !== id)
                if (this.activeTab === 'Returned') {
                    await UniformsService.deleteReturnedUniformRequest(id)
                }  else {
                    await UniformsService.deleteRequest(id)
                }
                this.$showSuccessMessageDelete("The request was successfully deleted");
            } catch (error) {
                this.$showErrorMessage("The request was not deleted. Server error. Please try again.");
            }
        },

        async getReturnedUniforms() {
            try {
                const {data: response} = await UniformsService.getReturnedUniforms(this.userInfo.id)
                this.pagination.current_page = response.current_page
                this.pagination.last_page = response.last_page
                this.uniformRequests = response.data.map(request => ({
                    created_at: request.created_at,
                    id: request.id,
                    quantity: request.quantity,
                    address: request.request.address,
                    size:request.request.size,
                    uniform: request.request.uniform
                }));
                this.loading = false
            } catch (e) {
                console.error(e)
                this.$showErrorMessage("The list of uniform return requests was not loaded")
            }
        },
        async getStatusList() {
            try {
                const {data: statuses} = await UniformsService.getStatusList()
                this.statusList = statuses
            } catch (e) {
                this.$showErrorMessage("The list of uniform statuses was not loaded");
            }
        },
        showExtraTab(tab) {
            if (tab === 'Return') {
                this.showNewReturnRequest = true
                this.showNewRequest = false
                this.showList = false
            } else if (tab === 'NewRequest') {
                this.showNewRequest = true
                this.showNewReturnRequest = false
                this.showList = false
            } else {
                this.showNewRequest = false
                this.showNewReturnRequest = false
                this.showList = true
            }
        },

        async updateStatus(request) {
            this.$showLoadingMessage()
            try {
                await UniformsService.updateRequestStatus(request.id, request.status_id)

                this.$showSuccessMessage('Status was updated')
                await this.getListOfApplicantsUniformRequests()
            } catch (e) {
                this.$showErrorMessage('Status was not updated. Please try again');
            }
        },
    },
    mounted() {
        this.loadData()
    }

}

</script>

<style scoped>

</style>
